<template>
  <div :class="standalone ? '' : 'card bdr-rad2 mt-3 shadow p-2'">
    <div :class="standalone ? '' : 'card-body'">
      <div v-if="!standalone" class="scheduled-section-title">
        Employee Training Requirement
      </div>
      <div v-if="errorMessage" class="alert alert-danger mt-2">
        {{ errorMessage }}
      </div>
      <div
        style="border: 0; padding: 0; min-height: 0"
        class="navbar background_color"
      >
        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px">
            <b-form-input
              v-model="search"
              type="search"
              placeholder="Search"
              class="bdr-rad"
            />
          </b-input-group>
          <div style="margin-top: 11px" class="ms-2">
            <span class="custom-breadcrumb"
              >Showing {{ displayStart }}-{{ displayEnd }} of
              {{ filteredRows.length }} items.</span
            >
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="d-flex justify-content-center py-4">
        <div class="spinner-border text-primary"></div>
      </div>
      <div
        v-else
        class="table-responsive"
        :class="standalone ? 'card bdr-rad2 mt-1 shadow p-2' : ''"
      >
        <b-table
          responsive
          class="table-hover"
          style="font-size: small"
          :items="paginatedRows"
          :fields="fields"
          head-variant="dark"
          show-empty
          small
          empty-text="No employee training requirements found."
        >
          <template #cell(fin_nric)="row">{{
            row.item.fin_nric || "-"
          }}</template>
          <template #cell(designation)="row">{{
            row.item.designation || "-"
          }}</template>
          <template #cell(site)="row">{{ row.item.site || "-" }}</template>
          <template #cell(courses_needed)="row">
            <div
              v-for="(course, index) in lines(row.item.courses_needed)"
              :key="'need-' + row.item.id + '-' + index"
            >
              * {{ course }}
            </div>
            <span v-if="!row.item.courses_needed">-</span>
          </template>
          <template #cell(courses_completed)="row">
            <div
              v-for="(course, index) in lines(row.item.courses_completed)"
              :key="'done-' + row.item.id + '-' + index"
            >
              * {{ course }}
            </div>
            <span v-if="!row.item.courses_completed">-</span>
          </template>
        </b-table>
        <b-col style="padding-left: 0" sm="7" md="2" class="my-1 mb-4"
          ><b-pagination
            v-model="currentPage"
            pills
            :total-rows="filteredRows.length"
            :per-page="perPage"
            size="sm"
        /></b-col>
      </div>
    </div>
    <br><br>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";

export default {
  props: { standalone: { type: Boolean, default: false } },
  data() {
    return {
      token: authService.isLoggedIn(),
      rows: [],
      search: "",
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      errorMessage: "",
      fields: [
        { key: "fin_nric", label: "FIN / NRIC" },
        { key: "name", label: "Name" },
        { key: "designation", label: "Designation" },
        { key: "site", label: "Site" },
        {
          key: "courses_needed",
          label: "Courses Need to Complete for Position",
        },
        { key: "courses_completed", label: "Courses Completed" },
      ],
    };
  },
  computed: {
    filteredRows() {
      const value = this.search.toLowerCase();
      return this.rows.filter(
        (item) =>
          !value ||
          [
            item.fin_nric,
            item.name,
            item.designation,
            item.site,
            item.courses_needed,
            item.courses_completed,
          ]
            .join(" ")
            .toLowerCase()
            .includes(value)
      );
    },
    paginatedRows() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredRows.slice(start, start + this.perPage);
    },
    displayStart() {
      return this.filteredRows.length
        ? (this.currentPage - 1) * this.perPage + 1
        : 0;
    },
    displayEnd() {
      return Math.min(
        this.currentPage * this.perPage,
        this.filteredRows.length
      );
    },
  },
  mounted() {
    this.loadRequirements();
  },
  methods: {
    async loadRequirements() {
      try {
        const { data } = await axios.get(
          "/ticourses/employee-training-requirements",
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.rows = data.data || [];
      } catch (error) {
        this.errorMessage = "Unable to load employee training requirements.";
      } finally {
        this.isLoading = false;
      }
    },
    lines(value) {
      return String(value || "")
        .split(/\r?\n|<br\s*\/?>(?=\s*\*)/i)
        .map((line) => line.replace(/^\*\s*/, "").trim())
        .filter(Boolean);
    },
  },
};
</script>
